import { normalizePerson } from './content';

/**
 * Resolve publication authors for display (full view and listing cards).
 *
 * Prefers enriched relation objects (related_authors), then catalog metadata
 * (related_authors_info).
 */

function isRelationAuthorObject(author) {
  if (!author || typeof author !== 'object') return false;
  return Boolean(
    author['@type'] ||
      author['@id'] ||
      author.is_linkable != null ||
      author.publication_name ||
      author.full_name,
  );
}

export function resolvePublicationAuthors(item) {
  const relatedAuthors = Array.isArray(item?.related_authors)
    ? item.related_authors
    : [];
  const relationObjects = relatedAuthors
    .map(normalizePerson)
    .filter(isRelationAuthorObject);

  if (relationObjects.length > 0) {
    return relationObjects;
  }

  const info = Array.isArray(item?.related_authors_info)
    ? item.related_authors_info
    : [];
  return info;
}
